import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Descripción técnica completa de cada seña', 'Expresión facial y postura corporal para cada seña', 'Frases y narrativas con estructura en LSA', 'Checklists de práctica y autoevaluación', 'Contexto cultural argentino en cada sección', 'Errores frecuentes y cómo evitarlos', 'Desafíos progresivos por nivel', 'Referencia cruzada entre tomos', 'Optimizado para celular, tablet e imprimir', '100% basado en el LSA argentino 2026'];
  return <section className="py-12 bg-slate-950 border-y border-slate-800" data-id="element-179">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-180">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-181">
          Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-182">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-900 transition-colors" data-id="element-183">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-184" />
              <span className="text-slate-200 font-medium" data-id="element-185">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}